import { render, staticRenderFns } from "./bookdropComp.vue?vue&type=template&id=d5ab1d0e&scoped=true"
import script from "./bookdropComp.vue?vue&type=script&lang=js"
export * from "./bookdropComp.vue?vue&type=script&lang=js"
import style0 from "./bookdropComp.vue?vue&type=style&index=0&id=d5ab1d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ab1d0e",
  null
  
)

export default component.exports